import { Link } from "react-router-dom";
import { useCopy, useFramework } from "../framework";
import { iconFor } from "./icons";
import { ArrowLinkLabel } from "./ui";

export function OfficeProductCards() {
  const { snapshot } = useFramework();
  const copy = useCopy();
  const products = [...(snapshot.content.officeProducts ?? [])].sort((a, b) => a.order - b.order);

  return (
    <div className="apf-office-pair" data-office-product-cards>
      {products.map((product) => {
        const ProductIcon = iconFor(product.icon);
        return (
          <article className="apf-office-entry" key={product.id}>
            <p className="apf-office-entry__program">{copy(product.programKey)}</p>
            <p className="apf-office-entry__eyebrow">
              <ProductIcon size={20} />
              <span>{copy(product.nameKey)} · {copy(product.formatKey)}</span>
            </p>
            <h3>{copy(product.taglineKey)}</h3>
            <p>{copy(product.summaryKey)}</p>
            <p className="apf-office-entry__delivery">{copy(product.deliveryKey)}</p>
            <Link className="apf-office-entry__link" to={product.route}>
              <ArrowLinkLabel>{copy(product.specificationCtaKey)}</ArrowLinkLabel>
            </Link>
          </article>
        );
      })}
    </div>
  );
}
